export default class Group {
  slideshow;
  pageNumber;
  title;
  romance;
  features;
  products;
  showPromoProduct;
  promoProduct;
  images;
  snipeText;
  snipeColor;
  barcodeUrl;
  pageDigest;

  constructor(slideshow, groupWire, skuToProduct, imageByNameLowerCase, shortNames) {
    this.slideshow = slideshow;
    this.pageNumber = shortNames ? groupWire.pg_nm : groupWire.page_dto_page_number;
    this.title = shortNames ? groupWire.pg_tt : groupWire.page_dto_title;
    this.romance = shortNames ? groupWire.pg_rm : groupWire.page_dto_romance;
    this.features = shortNames ? groupWire.pg_ft : groupWire.page_dto_features;
    var dtoSkus = shortNames ? groupWire.pg_sk : groupWire.page_dto_skus;
    this.products = dtoSkus.map(sku => skuToProduct[sku]);
    this.showPromoProduct = shortNames ? groupWire.pg_sp : groupWire.page_dto_show_promo_product;
    var dtoPromoSku = shortNames ? groupWire.pg_ps : groupWire.page_dto_promo_product_sku;
    this.promoProduct = skuToProduct[dtoPromoSku];
    var dtoImages = shortNames ? groupWire.pg_px : groupWire.page_dto_pictures;
    this.images = dtoImages.map(picture => imageByNameLowerCase[picture.toLowerCase()]);
    this.snipeText = shortNames ? groupWire.pg_st : groupWire.page_dto_snipe_text;
    this.snipeColor = shortNames ? groupWire.pg_sc.ColorId : groupWire.page_dto_snipe_color.ColorId;
    this.barcodeUrl = shortNames ? groupWire.pg_bu : groupWire.page_dto_barcode_url;
    this.pageDigest = shortNames ? groupWire.pg_dg : groupWire.page_dto_page_digest;
  }

  filter(columnIdToValuesLowerCase) {
    return this.products.some(product => product.filter(columnIdToValuesLowerCase));
  }

  searchWeight(searchColumns, searchLowerCase) {
    var searchWeights = this.products.map(product => product.searchWeight(searchColumns, searchLowerCase));
    var maxSearchWeight = Math.max(...searchWeights);
    return maxSearchWeight;
  }
}
